// extracted by mini-css-extract-plugin
module.exports = {"noContentLabel":"pathwayContentMain_noContentLabel__1Tpxu"};